var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"max-width":_vm.maxWidth,"name":"auth-modal","height":"auto","scrollable":"","adaptive":""},on:{"before-open":_vm.handleModalBeforeOpen}},[_c('div',{staticClass:"py-8 px-10"},[_c(_vm.component,{tag:"component",attrs:{"email":_vm.email},on:{"change-component":_vm.changeComponent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }